import ShortUniqueId from "short-unique-id";

const createUniqueElementId = () => {
    const uid = new ShortUniqueId();
    return uid();
};

export default createUniqueElementId;
